export default __webpack_public_path__ + "static/media/pie.06247dc5.svg";